import { useDroppable } from "@dnd-kit/core";
import { ChevronLeft, ChevronRight } from "lucide-react";
import styles from "./Kanban.module.scss";
import KanbanCard from "./KanbanCard";

const KanbanLane = (props) => {
  const {
    title,
    items,
    setShowModal,
    selectedItem,
    setSelectedItem,
    setIsEdit,
    setModalTitle,
    setShowDeleteModal,
    handleMove,
    heightDelta,
    handleAction,
    isCollapsed,
    onToggleCollapse,
  } = props;
  const { setNodeRef } = useDroppable({
    id: title,
  });

  const getStatusPill = (status) => {
    switch (status) {
      case "In Progress":
        return "pill OnTrack";
      case "Monitoring":
        return "pill OffTrack";
      case "Slipping":
        return "pill AtRisk";
      case "Completed":
        return "pill Completed";
      case "On Hold":
        return "pill OnHold";
      default:
        return "";
    }
  };

  const getCollapsedColor = (status) => {
    switch (status) {
      case "In Progress":
        return "#10b981"; // green
      case "Monitoring":
        return "#f59e0b"; // orange
      case "Slipping":
        return "#ef4444"; // red
      case "Completed":
        return "#6366f1"; // indigo
      case "On Hold":
        return "#6b7280"; // gray
      default:
        return "#6b7280";
    }
  };

  const handleToggleCollapse = (e) => {
    e.stopPropagation();
    onToggleCollapse(title);
  };

  if (isCollapsed) {
    return (
      <div className={`${styles.laneCollapsed} ${getStatusPill(title)}`}>
        <div className={styles.laneCollapsedHeader} onClick={handleToggleCollapse}>
          <ChevronRight size={16} className={styles.collapseIconVertical} />
          <span className={styles.laneCollapsedTitle}>{title}</span>
          <span className={styles.laneCollapsedCount}>{items.length}</span>
        </div>
      </div>
    );
  }

  return (
    <div 
      ref={setNodeRef} 
      className={`${styles.kanbanWrapper}`}
      style={{minHeight : `calc(100vh - ${heightDelta})`}}
      >
      <div className={styles.laneHeader}>
        <div className={`${styles.laneTitlePill} ${getStatusPill(title)}`}>
          <ChevronLeft 
            size={16} 
            className={styles.collapseIcon}
            onClick={handleToggleCollapse}
          />
          <span className={styles.laneTitle}>{title}</span>
          <span className={styles.laneCount}>{items.length}</span>
        </div>
      </div>
      <div className="px-3 py-2">
      {items.map((title, key) => (
        <KanbanCard
          title={title}
          details={title}
          key={key}
          index={key}
          parent={title}
          setShowModal={setShowModal}
          selectedItem={selectedItem}
          handleMove={handleMove}
          setSelectedItem={setSelectedItem}
          setIsEdit={setIsEdit}
          setModalTitle={setModalTitle}
          setShowDeleteModal={setShowDeleteModal}
          handleAction={handleAction}
        />
      ))}
      </div> 
    </div>
  );
};
export default KanbanLane;
